import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

/**
 * Service gérant les requêtes http synchrone et asynchrone
 *
 * @public
 * @class
 * @classdesc Service gérant les requêtes http synchrone et asynchrone
 */
@Injectable({
  providedIn: 'root',
})
export class RequesterService {
  /**
   * @constructor
   *
   * @param {HttpClient}  http
   */
  constructor(private http: HttpClient) {}

  /**
   * Méthode permettant l'envoi d'une requête HTTP POST de façon asynchrone
   *
   * @param {string}    destination  adresse destinataire
   * @param {FormData}  data         données constituant le corps de la requête
   */
  httpPostingAsynchronously(destination: string, data: FormData): void {
    this.http.post(destination, data).subscribe();
  }

  /**
   * Méthode permettant l'envoi d'une requête HTTP POST de façon synchrone
   *
   * @param {string}    destination Adresse destinataire
   * @param {FormData}  data        Données constituant le corps de la requête
   */
  httpPostingSynchronously$(
    destination: string,
    data: FormData,
    notEkgStandard?: boolean
  ): Observable<any> {
    const optionsInRequest = {
      observe: 'response', // to display the full response & as 'body' for type cast
    };
    return this.http.post(destination, data, optionsInRequest as any).pipe(
      catchError(this.handlePostError),
      map((postResponse: any) => {
        if (notEkgStandard) {
          return postResponse;
        } else {
          if (postResponse) {
            if (postResponse.error) {
              return postResponse.error;
            } else if (postResponse.body && postResponse.body.response) {
              return postResponse.body.response;
            }
          }
        }
      })
    );
  }

  handlePostError(error: HttpErrorResponse) {
    return of(error);
  }

  handleGetError(error: HttpErrorResponse, destination: string) {
    if (destination.includes('/auth/token') && error.status !== 401)
      return throwError(error);
    return of(error);
  }

  /**
   * Méthode permettant l'envoi d'une requête HTTP GET de façon synchrone
   *
   * @param {string}  destination     Adresse destinataire
   * @param           options         Options pour la requête GET
   * @param {boolean} notEkgStandard  Réponse non standard
   */
  httpGettingSynchronously$(
    destination: string,
    options?,
    notEkgStandard?: boolean
  ): Observable<any> {
    return this.http.get(destination, options).pipe(
      map((getResponse: any) => {
        if (notEkgStandard) {
          return getResponse;
        } else {
          if (getResponse) {
            if (getResponse.error) {
              return getResponse.error;
            } else if (getResponse.response) {
              return getResponse.response;
            }
          }
        }
      }),
      catchError((error) => this.handleGetError(error, destination))
    );
  }
}
